module.exports = __webpack_public_path__ + "static/supermate-36bfa39f3452f1df0564a2dbcc82d0fa.jpg";